import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link as MuiLink,
  IconButton,
  List,
  ListItem,
} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import api from '../services/api';

const Footer = () => {
  const [practiceAreas, setPracticeAreas] = useState([]);

  useEffect(() => {
    const fetchPracticeAreas = async () => {
      try {
        const response = await api.get('/practice-areas');
        setPracticeAreas(response.data.slice(0, 10));
      } catch (error) {
        console.error('Error fetching practice areas:', error);
      }
    };
    fetchPracticeAreas();
  }, []);

  const servicesList = [
    'Legal Consultation',
    'Court Representation',
    'Document Review',
    'Contract Drafting',
    'Mediation Services',
    'Legal Research',
    'Property Matters',
    'Consumer Disputes',
    'Cyber Law Cases',
    'Court Marriage Registration',
  ];

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#0B1F33',
        color: 'rgba(248,250,252,0.96)',
        py: { xs: 4, md: 6 },
        mt: 'auto',
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={{ xs: 3, md: 4 }}>
          {/* About Section */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontWeight: 700, letterSpacing: '0.05em', fontSize: { xs: '0.9rem', md: '1rem' } }}
            >
              ADVOCATE PRIYANKA SWAMI
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, fontSize: { xs: '0.8rem', md: '0.875rem' } }}>
              At Advocate Priyanka Swami, we are more than just a law firm – we are your trusted
              legal partners, dedicated to guiding you through the complexities of law with clarity,
              compassion, and expertise.
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <IconButton
                sx={{ color: 'white', p: 1 }}
                component="a"
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon sx={{ fontSize: { xs: 20, md: 24 } }} />
              </IconButton>
              <IconButton
                sx={{ color: 'white', p: 1 }}
                component="a"
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <TwitterIcon sx={{ fontSize: { xs: 20, md: 24 } }} />
              </IconButton>
              <IconButton
                sx={{ color: 'white', p: 1 }}
                component="a"
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedInIcon sx={{ fontSize: { xs: 20, md: 24 } }} />
              </IconButton>
            </Box>
          </Grid>

          {/* Our Expertise */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontSize: { xs: '0.95rem', md: '1rem' } }}>
              Our Expertise
            </Typography>
            <List dense sx={{ p: 0 }}>
              {practiceAreas.map((area) => (
                <ListItem key={area._id} disablePadding sx={{ mb: 0.5 }}>
                  <MuiLink
                    component={Link}
                    to="/practice-areas"
                    color="inherit"
                    sx={{
                      fontSize: { xs: '0.8rem', md: '0.875rem' },
                      textDecoration: 'none',
                      opacity: 0.9,
                      '&:hover': {
                        opacity: 1,
                        color: 'secondary.light',
                      },
                    }}
                  >
                    {area.title}
                  </MuiLink>
                </ListItem>
              ))}
            </List>
          </Grid>

          {/* Our Services */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontSize: { xs: '0.95rem', md: '1rem' } }}>
              Our Services
            </Typography>
            <List dense sx={{ p: 0 }}>
              {servicesList.map((service) => (
                <ListItem key={service} disablePadding sx={{ mb: 0.5 }}>
                  <MuiLink
                    component={Link}
                    to="/services"
                    color="inherit"
                    sx={{
                      fontSize: { xs: '0.8rem', md: '0.875rem' },
                      textDecoration: 'none',
                      opacity: 0.9,
                      '&:hover': {
                        opacity: 1,
                        color: 'secondary.light',
                      },
                    }}
                  >
                    {service}
                  </MuiLink>
                </ListItem>
              ))}
            </List>
          </Grid>

          {/* Contact Us */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontSize: { xs: '0.95rem', md: '1rem' } }}>
              Contact Us
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <PhoneIcon sx={{ fontSize: 18, mt: 0.25, flexShrink: 0 }} />
                <Typography variant="body2" sx={{ fontSize: { xs: '0.8rem', md: '0.875rem' } }}>
                  +91 88006 56660
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <EmailIcon sx={{ fontSize: 18, mt: 0.25, flexShrink: 0 }} />
                <Typography variant="body2" sx={{ fontSize: { xs: '0.8rem', md: '0.875rem' } }}>
                  advpriyankaswami@gmail.com
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <LocationOnIcon sx={{ fontSize: 18, mt: 0.25, flexShrink: 0 }} />
                <Box>
                  <Typography variant="body2" sx={{ fontSize: { xs: '0.8rem', md: '0.875rem' }, mb: 0.5 }}>
                    F-13, Jangpura, New Delhi - 110014
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: { xs: '0.75rem', md: '0.8rem' }, opacity: 0.8 }}>
                    Supreme Court of India, New Delhi
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: { xs: '0.75rem', md: '0.8rem' }, opacity: 0.8 }}>
                    Tis Hazari Court, Delhi
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ mt: { xs: 3, md: 4 }, pt: { xs: 2, md: 3 }, borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <Typography
            variant="body2"
            align="center"
            sx={{ fontSize: { xs: '0.75rem', md: '0.875rem' }, opacity: 0.9 }}
          >
            © {new Date().getFullYear()} All Rights Reserved | Advocate Priyanka Swami
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;

